import api from '../../utils/andromeda-api';

/**
 * Fetch usage aggregated by saved row (all organizations).
 * @param {string} [startDate] - ISO date string
 * @param {string} [endDate] - ISO date string
 * @returns {Promise<{ results: Array }>}
 */
export async function getUsageByRow(startDate, endDate) {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const { data } = await api.get('/universalRowsUsage/usage-by-row', {
      params,
    });
    return data;
  } catch (error) {
    console.error('Error fetching usage by row', error);
  }
}

/**
 * Fetch usage aggregated by customer/organization (all organizations).
 * @param {string} [startDate] - ISO date string
 * @param {string} [endDate] - ISO date string
 * @returns {Promise<{ results: Array }>}
 */
export async function getUsageByCustomer(startDate, endDate) {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const { data } = await api.get('/universalRowsUsage/usage-by-customer', {
      params,
    });
    return data;
  } catch (error) {
    console.error('Error fetching usage by customer', error);
  }
}
